export default __webpack_public_path__ + "static/symbol-wheel-51293fcde10668131b92d8935e6e5eda.webp";